import React from "react";
import { FlameIcon } from "lucide-react";
type ScarcityBarProps = {
  dark?: boolean;
};
const SPOTS_LEFT = 7;
const CLAIMED_PERCENT = 93;
export function ScarcityBar({
  dark = false
}: ScarcityBarProps) {
  return <div className="w-full" data-id="element-76" data-mp="2l44uaghe0pep">
      <div className={`flex flex-wrap items-center justify-between gap-x-3 gap-y-1 text-sm font-semibold ${dark ? "text-white" : "text-ink"}`} data-id="element-77" data-mp="2l2traivrnlon">
        <span className="flex items-center gap-1.5" data-id="element-78" data-mp="2b56xkq9t5pkm">
          <FlameIcon className="h-4 w-4 shrink-0 text-alert" aria-hidden="true" data-id="element-79" data-mp="2g5l9ijej5jnx" />
          Only <strong className="text-alert" data-id="element-80" data-mp="22620zpht46b3">{SPOTS_LEFT} spots left</strong> at the $27 price
        </span>
        <span className={dark ? "text-white/70" : "text-muted"} data-id="element-81" data-mp="274ve3gt6lvaq">{CLAIMED_PERCENT}% claimed</span>
      </div>
      <div className={`mt-2 h-4 w-full overflow-hidden rounded-full ${dark ? "bg-white/15" : "bg-navy-900/10"}`} role="progressbar" aria-valuenow={CLAIMED_PERCENT} aria-valuemin={0} aria-valuemax={100} aria-label="Promotional spots claimed" data-id="element-82" data-mp="eypyz408pq0">
        <div className="h-full rounded-full bg-alert" style={{
        width: `${CLAIMED_PERCENT}%`
      }} data-id="element-83" data-mp="2zlji4gjmotyl" />
      </div>
    </div>;
}